(function () {
  function formatMoney(cents, currencyCode) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      const themeFormat =
        (typeof theme !== 'undefined' && theme.moneyFormat) ||
        (typeof DT_THEME !== 'undefined' && DT_THEME.moneyFormat) ||
        (window.theme && window.theme.moneyFormat) ||
        '${{amount}}';
      return Shopify.formatMoney(cents, themeFormat);
    }

    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currencyCode || 'INR',
        maximumFractionDigits: 2
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  function getQtyInput(sectionId, formId) {
    return (
      document.querySelector('#Quantity-' + sectionId) ||
      document.querySelector('form#' + formId + ' input[name="quantity"]') ||
      document.querySelector('.product-form input[name="quantity"]')
    );
  }

  function getSelectedQty(root) {
    const selected =
      root.querySelector('.product-qty-packs__card.is-selected') ||
      root.querySelector('.product-qty-packs__card');
    return parseInt(selected?.dataset.qty || '1', 10);
  }

  function initPackGroup(root) {
    const sectionId = root.dataset.sectionId;
    const formId = root.dataset.formId;
    const cards = root.querySelectorAll('.product-qty-packs__card');
    if (!cards.length) return;

    const qtyInput = getQtyInput(sectionId, formId);
    const productForm = document.querySelector('form#' + formId);
    const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    const variantsJson = root.querySelector('.product-qty-packs__variants-json');
    const currencyCode = root.dataset.currency || 'INR';
    let variants = [];

    try {
      variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    } catch (e) {
      variants = [];
    }

    function getVariantById(id) {
      const variantId = String(id || '');
      return variants.find(function (variant) {
        return String(variant.id) === variantId;
      });
    }

    function updatePackPrices(variantId) {
      const variant = getVariantById(variantId);
      const unitPrice = variant && typeof variant.price !== 'undefined'
        ? parseInt(variant.price, 10)
        : parseInt(root.dataset.unitPrice || '0', 10);

      root.dataset.unitPrice = unitPrice;

      cards.forEach(function (card) {
        const qty = parseInt(card.dataset.qty || '1', 10);
        const priceEl = card.querySelector('.product-qty-packs__price');
        if (priceEl) {
          priceEl.textContent = formatMoney(unitPrice * qty, currencyCode);
        }
      });
    }

    function applyQty(qty) {
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.setAttribute('value', qty);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    function selectCard(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      applyQty(parseInt(card.dataset.qty || '1', 10));
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectCard(card);
      });
    });

    const selected = root.querySelector('.product-qty-packs__card.is-selected') || cards[0];
    if (selected) selectCard(selected);
    if (variantInput) {
      updatePackPrices(variantInput.value);
      variantInput.addEventListener('change', function () {
        updatePackPrices(variantInput.value);
      });
    }

    if (productForm) {
      productForm.addEventListener('submit', function () {
        applyQty(getSelectedQty(root));
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.product-qty-packs').forEach(initPackGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
